interface Props {
  id: number
  radius: number
  padding: number
  point1:
    | {
        x: number
        y: number
      }
    | undefined
  point2:
    | {
        x: number
        y: number
      }
    | undefined
  sliceColor: string
  isWhole?: boolean
  callback?: (index: number) => void | undefined
}

export default function SliceCompo({
  id,
  radius,
  padding,
  point1,
  point2,
  sliceColor,
  isWhole = false,
  callback,
}: Props): React.ReactElement {
  const handleClick = (): void => {
    if (callback) callback(id)
  }

  // A single slice is the whole circle: its arc would start and end at the same point, and SVG draws
  // nothing for that, leaving only the radius line (0/1 in the denominator task).
  if (isWhole) {
    return (
      <circle
        cx={radius + padding}
        cy={radius + padding}
        fill={sliceColor}
        onClick={handleClick}
        r={radius}
        stroke="black"
      />
    )
  }

  return (
    <path
      d={`M ${radius + padding} ${radius + padding} L ${point2?.x} ${point2?.y} 
      A ${radius} ${radius} 0 0 0 ${point1?.x} ${point1?.y} z`}
      fill={sliceColor}
      onClick={handleClick}
      stroke="black"
    />
  )
}
